import type { GridActionsCellItemProps } from '@mui/x-data-grid-pro';

import { useMemo, Fragment } from 'react';

import Link from '@mui/material/Link';
import { GridActionsCellItem } from '@mui/x-data-grid-pro';
import { menuItemClasses } from '@mui/material/MenuItem';

// ----------------------------------------------------------------------

type CustomGridActionsCellItemProps = GridActionsCellItemProps & {
  href?: string;
};

const isExternalLink = (href: string) => href.startsWith('http');

const getLinkProps = (href?: string) => {
  if (!href) return {};

  return isExternalLink(href)
    ? { component: Link, href, target: '_blank', rel: 'noopener noreferrer' }
    : { component: Link, href };
};

export function CustomGridActionsCellItem({
  href,
  showInMenu,
  ...other
}: CustomGridActionsCellItemProps) {
  const linkProps = useMemo(() => getLinkProps(href), [href]);
  const Wrapper = href ? 'li' : Fragment;

  if (showInMenu) {
    return (
      <Wrapper {...(href && { className: menuItemClasses.root })}>
        <GridActionsCellItem
          {...(other as Extract<CustomGridActionsCellItemProps, { showInMenu?: true }>)}
          {...linkProps}
          showInMenu
        />
      </Wrapper>
    );
  }

  return (
    <GridActionsCellItem
      {...(other as Extract<CustomGridActionsCellItemProps, { showInMenu?: false }>)}
      {...linkProps}
      showInMenu={false}
    />
  );
}

